import React, { useState, useEffect } from "react";
import { INotificationData } from "../MobileAppTypes";
import { NotificationController } from "./NotificationController";
import NotificationList from "./NotificationList";
import NotificationForm from "./NotificationForm";
import Button from "../../_Core/Button";
import Modal from "../../Modal/Modal";

interface INotificationManagerProps {
  appId: string;
}

type TabType = 'list' | 'create';

const NotificationManager: React.FC<INotificationManagerProps> = ({ appId }) => {
  const [notifications, setNotifications] = useState<INotificationData[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    loadNotifications();
  }, [appId]);

  const loadNotifications = async () => {
    setIsLoading(true);
    
    try {
      const response = await NotificationController.listNotifications(appId);
      
      if (response.Success) {
        setNotifications(response.Value || []);
      } else {
        setNotifications([]);
      }
    } catch (error) {
      console.error('Error loading notifications:', error);
      setNotifications([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleNotificationCreated = () => {
    // Refresh the notification list
    loadNotifications();
  };

  const handleRefresh = () => {
    loadNotifications();
  };

  return (
    <div>

      <div >
          <NotificationList
            notifications={notifications}
            onRefresh={handleRefresh}
            isLoading={isLoading}
            requestNew={() => setShowForm(true)}
          />
          {showForm && <Modal setModalOpen={setShowForm} size="l" title="New Notification">
            <NotificationForm
                appId={appId}
                onNotificationCreated={handleNotificationCreated}
                onCancel={() => setShowForm(false)}
            />
          </Modal>}
      </div>
    </div>
  );
};

export default NotificationManager;